// TODO: Fix these dependencies if we export this as a package
// import Metrics from 'services/metrics'
import IdStoreModule from './module'
import {ID_NAMESPACE} from './module/types'
import * as _ from 'lodash'
import {USER_COUNTRY_CODE} from '../../../enums/local-storage-keys'
// Shortcut.  Assigned in initialize() -> window.smartidAsyncInit.
let ID = null

export default {
  clientId: '',
  scopes: ['profile'],
  sessionErrorListener: null,
  store: null,
  from: '',
  redirectURI: (window.location.protocol + '//' + window.location.host) + '/login',
  country: '',

  injectSMARTID(id, clientId, additionalScopes) {
    ID = id
    this.country = window.localStorage.getItem(USER_COUNTRY_CODE)
    this.clientId = clientId || ''
    this.scopes = this.scopes.concat(additionalScopes || [])
  },
  getName() {
    return ID_NAMESPACE
  },

  getStoreModule() {
    return IdStoreModule
  },
  load(store) {
    this.store = store
    return new Promise((resolve, reject) => {
      ID.addLoginListener(() => {
        this.store.commit('auth/id/SET_ERROR', {})

        ID.getProfile((profile) => {
          let state = ID.getState()
          if (state) {
            try {
              let stateJson = JSON.parse(state)

              if (stateJson.from) {
                this.setFrom(stateJson.from)
              }
            } catch (e) {
              console.warn('Invalid state parameter from ID:', state)
              state = null
            }
          }
          try {
            this.store.commit('auth/id/SET_PROFILE', {
              uid: profile.id,
              name: profile.name,
              email: profile.email,
              picture: profile.picture
            })

            this.store.commit('auth/id/LOGIN', {
              roles: profile.roles,
              accessToken: ID.getAccessToken()
            })
          } catch (e) {
            console.log(e)
          }

          resolve()
        })
      })

      ID.addLogoutListener(() => {
        this.store.commit('auth/id/SET_ERROR', {})

        this.store.commit('auth/id/LOGOUT')
        resolve()
      })

      ID.addErrorListener((error) => {
        // Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.SLSO_TAGS.ID_TRANSACTION_FAILURE, 1, Metrics.TYPE.FAILURE_COUNTER)
        this.store.commit('auth/id/SET_ERROR', error)

        if (this.sessionErrorListener) {
          // TODO: Figure out what errors can happen and display appropriately
          switch (error.errorCode) {
            case 'session_error':
            case 'invalid_access_token':
              this.sessionErrorListener(error)
          }
        }

        reject(error)
      })

      ID.addTokenListener((tokenInfo) => {
        if (tokenInfo) {
          this.store.commit('auth/id/REFRESH_TOKEN', tokenInfo.accessToken)
        }
      })

      ID.init({
        client_id: this.clientId,
        redirect_uri: this.redirectURI,
        scope: this.scopes,
        cookie_path: '/',
        persist_state: true
      })
    })
  },
  isAuthenticated(role) {
    let authenticated = this.store.getters['auth/id/authenticated']
    if (role) {
      authenticated = authenticated && this.getRoles().includes(role)
    }
    return authenticated
  },
  getAccessToken() {
    return this.store.state.auth.id.accessToken
  },
  // TODO: getProfile and getUserData are confusing names.
  getProfile(callback) {
    return ID.getProfile(callback)
  },
  getUserData() {
    return {
      id: this.store.state.auth.id.uid,
      name: this.store.state.auth.id.name,
      picture: this.store.state.auth.id.picture,
      email: this.store.state.auth.id.email
    }
  },
  getRoles() {
    return this.store.state.auth.id.roles
  },
  getState() {
    return ID.getState()
  },
  createStateForIDRedirect() {
    let state = {
      // If no 'from' path is set, default to /login and preserve the query params
      from: this.from || '/' + window.location.search
    }

    return state
  },
  setSessionErrorListener(listener) {
    this.sessionErrorListener = listener
  },
  signIn(state) {
    if (_.isUndefined(state)) {
      state = this.createStateForIDRedirect()
    }
    ID.login(JSON.stringify(state), {country: this.country})
  },
  signUp(state) {
    if (_.isUndefined(state)) {
      state = this.createStateForIDRedirect()
    }
    ID.login(JSON.stringify(state), {'prompt': 'signup'})
  },
  signOut() {
    this.sessionErrorListener = null
    ID.logout()
  },
  getFrom() {
    return this.from
  },
  setFrom(path) {
    this.from = path
  }
}
